import React from "react";
import { Link } from "react-router-dom";
import "../../common/bg.css";
import "./c.css";
import WebsiteName from "../../common/WebsiteName/WebsiteName";
import Navbar from "../../common/Navbar/NavBar";
import Location from "../../common/Location/Location";
import Footer from "../../common/Footer/Footer";
export default function C_info() {
  return (
    <>
      <section className="bgImageCommon">
        <WebsiteName />
        <Navbar />
        <Location title="Python" />
        <section>
          <div className="cBody">
            <div id="cardDIV">
              <h1 className="text-dark" id="laguage_Title">
                Python
              </h1>
              <p className="text-secondary" id="Language_Para">
                Python is among the most widely used programming languages that
                developers use in the present. Guido Van Rossum created it in
                1991, and since its beginning, it has been among the most
                popular languages alongside C++, Java, and others.
                <br />
                Python is among the most widely used programming languages that
                developers use in the present. Guido Van Rossum created it in
                1991, and since its beginning, it has been among the most
                popular languages alongside C++, Java, and others.
                <br />
                Python can be described as an Interpreted language, which is, in
                simple terms, implies that it doesn't require compilation into
                machine language instruction prior to execution, and it is able
                to be utilized by the programmer directly to execute the
                program. This makes it a sufficient language to be used using an
                emulator or a virtual machine that is based on an existing
                machine's native code that is the language that hardware can
                understand.
                <br />
                It is a High-Level Programming language that is employed in
                complex scenarios. High-level languages handle arrays,
                variables, objects, and complex arithmetic, Boolean expressions,
                as well as other abstract concepts in computer science in order
                to be more complete and thereby increase their use.
              </p>
              <Link
                name=""
                id=""
                class="btn btn-danger"
                to="/Courses"
                role="button">
                {"<< "}back
              </Link>
            </div>
          </div>
        </section>
        <Footer />
      </section>
    </>
  );
}
